import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ClickAwayListener, Grid, List, ListItemButton, ListItemIcon, ListItemText, Paper, Popper, Typography, useMediaQuery } from '@mui/material';

// project import
import IconButton from 'components/@extended/IconButton';
import Transitions from 'components/@extended/Transitions';
import AnimateButton from 'components/@extended/AnimateButton';

// assets
import { SettingOutlined,UserOutlined,GiftOutlined,PhoneOutlined } from '@ant-design/icons';
import LoadingButton from "../../../../components/@extended/LoadingButton";
// ==============================|| HEADER CONTENT - Setting ||============================== //

const Setting = () => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const [call, setCall] = useState(false);
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleCron = async (e,type) => {
    try {
      if(type){
        setCall(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer vovl6wQdfY56OduOeEA3lUyOBt71F7uYbLLzMUw5QFBsZiAAAL9K0OIMh7m1JsC5OWrUkSPJkW4V3eUCU52Qoh7wUHolXmuVyUL0D5zTAiTq84dOgz0sKfw14bEyEjQMFyy0Wf9Zwy3um0WSubEJmP3idm395YioPqK4QDHdm4sF4wIaoZ7IkhtlJfsGUwk9MKXvhMqey9pxy98PJd9yI7QJA8fAdO8DJka1JflskG8EG26xrgODuJyc3X7oY455");

          const requestOptions = {
              method: "GET",
              headers: myHeaders,
              redirect: "follow"
          };
          const callFetch = await fetch("https://n8n.happ.tools/webhook/73e2f71e-03d9-4f26-9963-45772f191b44", requestOptions)
              .then((response) => response.json())
              .then((result) => console.log(result),setCall(false))
              .catch((error) => console.error(error));
      }

    } catch (err) {
      alert(err.data.errors[0].msg)
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'grey.100';

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        { window.location.hostname !== 'crm.aglar.in' &&
      <LoadingButton
          onClick={(e) => {handleCron(e,'call') }}
          loading={call}
          variant="contained"
          size="large"
          color="info" sx={{ mr: 1.1, height: '35px' }} >
          <PhoneOutlined />
      </LoadingButton>
        }
      <IconButton
          color="secondary"
          variant="light"
          sx={{ color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor }}
          onClick={handleToggle}
          ref={anchorRef}
          aria-label="open localization"
          aria-haspopup="true"
        >
          <AnimateButton type="rotate">
              <SettingOutlined />
          </AnimateButton>
        </IconButton>
      <Popper
        placement={matchesXs ? 'bottom-start' : 'bottom'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? 0 : 0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z1 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  component="nav"
                  sx={{
                    p: 0,
                    width: '100%',
                    minWidth: 200,
                    maxWidth: 290,
                    bgcolor: theme.palette.background.paper,
                    borderRadius: 0.5,
                    [theme.breakpoints.down('md')]: {
                      maxWidth: 250
                    }
                  }}
                >
                  <ListItemButton component={Link} to="/workers" selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
                    <ListItemIcon>
                        <UserOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Працівники" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/set-bonus" selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
                    <ListItemIcon>
                      <UserOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Бонус" />
                  </ListItemButton>
                </List>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default Setting;
